import * as React from "react";
const SvgFastforward = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-f2619d4d-5adf-466c-9e22-b2c89a1ba0ef", "data-name": "uuid-fbd6a643-e41f-4b28-bdab-0a326d2900b9", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z", style: {
  fill: "currentColor",
  stroke: "none",
  strokeLinecap: "round"
} }), /* @__PURE__ */ React.createElement("path", { d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z", style: {
  fill: "currentColor",
  stroke: "none",
  strokeLinecap: "round"
} }));
export default SvgFastforward;
